import menu from './menu';
import notifications from './notifications';

export default {
    rootPath: window.env.APP_URL,
    cmsPath: '/admin',
    cmsTitle: window.env.APP_NAME,
    routes: {
        default: '/dashboard',
        endpoints: {
            '^/pages': {
                params: { filter: 'parent_id:$null' },
            },
            '^/panels': {
                params: { filter: 'content_id:$null' },
            },
            '^/categories': {
                params: { filter: 'parent_id:$null' },
            },
            '^/resource_categories': {
                params: { filter: 'parent_id:$null' },
            },
            '^/customers': {
                params: { filter: 'registered:1' }
            },
            '^/enquiries': {
                params: { sort: 'created_at:desc' }
            },
            '^/news': {
                params: {
                    sort: 'available_at:desc'
                }
            },
            '^/resources': {
                params: {
                    sort: 'created_at:desc'
                }
            },
            '^/redirect_urls': {
                params: {
                    sort: 'created_at:desc'
                }
            },
            '^/subscribers': {
                params: { sort: 'created_at:desc' }
            },
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            csv: ['csv'],
        }
    },
    menu,
    notifications,
    inboxActive: false,
    assetPaginationPerpage: 20,
}
